import React from 'react';
import { oohData } from '../utils/oohData';
import { ListChecksIcon, TrendingUpIcon, WrenchIcon } from 'lucide-react';
export const TopStrengthsImprovements: React.FC = () => {
  const {
    topStrengths,
    topImprovements
  } = oohData;
  return <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-305" data-mp="1iqv8bmvbzmwf">
      <div className="flex items-center space-x-3 mb-2" data-id="element-306" data-mp="1dppgdr9hw3ny">
        <div className="p-2 bg-[#1E90FF]/10 text-[#1E90FF] rounded-lg" data-id="element-307" data-mp="1dsbpvwfy4t8t">
          <ListChecksIcon className="w-5 h-5" data-id="element-308" data-mp="1sm6p0aqav46t" />
        </div>
        <h2 className="text-lg font-medium text-gray-800" data-id="element-309" data-mp="1nowu4fk560bl">Key Takeaways</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6 max-w-3xl" data-id="element-310" data-mp="21fs2zrun4hf6">
        The reasoning behind the headline points in the executive summary, and
        what each one means for the next round of creative.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-311" data-mp="2bdpque8l8c79">
        {/* What to protect */}
        <div data-id="element-312" data-mp="26f4tcmkq06mi">
          <div className="flex items-center space-x-2 mb-4" data-id="element-313" data-mp="26fnyf2p9v0j4">
            <TrendingUpIcon className="export-icon-down h-5 w-5 text-green-600" data-id="element-314" data-mp="26d1tlatrmz4l" />
            <h3 className="text-sm font-semibold text-green-800 uppercase tracking-wider" data-id="element-315" data-mp="1bmyffne67rly">
              What to protect
            </h3>
          </div>

          <div className="space-y-3" data-id="element-316" data-mp="1lj1svpeh3co7">
            {topStrengths.map((strength, idx) => <div key={idx} className="bg-green-50/50 p-4 rounded-xl border border-green-100" data-id="element-317" data-mp="1plenbhnrro5o" data-mpi={idx}>
                <h4 className="text-sm font-bold text-gray-900 mb-1" data-id="element-318" data-mp="1ujpvzp2bvsmb">
                  {strength.name}
                </h4>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-319" data-mp="1zgq383awz1f0">
                  {strength.detail}
                </p>
              </div>)}
          </div>
        </div>

        {/* What to change */}
        <div data-id="element-320" data-mp="2dar5v84zl8kn">
          <div className="flex items-center space-x-2 mb-4" data-id="element-321" data-mp="2db8ylusfx4nt">
            <WrenchIcon className="export-icon-down h-5 w-5 text-amber-600" data-id="element-322" data-mp="2d8ms7yhacv76" />
            <h3 className="text-sm font-semibold text-amber-800 uppercase tracking-wider" data-id="element-323" data-mp="2i9txnqvyhiao">
              What to change
            </h3>
          </div>

          <div className="space-y-3" data-id="element-324" data-mp="e694ogknjssi">
            {topImprovements.map((improvement, idx) => <div key={idx} className="bg-amber-50/50 p-4 rounded-xl border border-amber-100" data-id="element-325" data-mp="rxnt52xbwm6y" data-mpi={idx}>
                <h4 className="text-sm font-bold text-gray-900 mb-1" data-id="element-326" data-mp="n52zc1efa93f">
                  {improvement.name}
                </h4>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-327" data-mp="ww7f33bx9xzb">
                  {improvement.detail}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};